"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVideo = void 0;
var _react = require("react");
const useVideo = function () {
  let initialHoverState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  let initialModalState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let override = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const [hovering, updateHovering] = (0, _react.useState)(initialHoverState);
  const [modalDeployed, updateModalDeployed] = (0, _react.useState)(initialModalState);
  const [playing, updatePlaying] = (0, _react.useState)(false);
  const deployModal = () => {
    if (typeof document !== "undefined" && typeof window !== "undefined") {
      document.body.style.overflow = "hidden";
      document.body.classList.add("video-modal-deployed");
      updatePlaying(false);
      updateModalDeployed(true);
    }
  };
  const hideModal = () => {
    if (typeof document !== "undefined" && typeof window !== "undefined") {
      updatePlaying(false);
      updateModalDeployed(false);
      document.body.style.overflow = "visible";
      document.body.classList.remove("video-modal-deployed");
    }
  };
  const setHovering = bool => {
    updateHovering(bool);
  };
  const togglePlaying = bool => {
    updatePlaying(bool);
  };
  return {
    hovering,
    modalDeployed,
    playing,
    deployModal,
    hideModal,
    setHovering,
    togglePlaying
  };
};
exports.useVideo = useVideo;